import { render, staticRenderFns } from "./DownloadWithTableButton.vue?vue&type=template&id=1f468c1a&scoped=true&"
import script from "./DownloadWithTableButton.vue?vue&type=script&lang=js&"
export * from "./DownloadWithTableButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadWithTableButton.vue?vue&type=style&index=0&id=1f468c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f468c1a",
  null
  
)

export default component.exports